import { render, staticRenderFns } from "./CreateTaxRate.vue?vue&type=template&id=0b6b4064&scoped=true"
import script from "./CreateTaxRate.vue?vue&type=script&lang=js"
export * from "./CreateTaxRate.vue?vue&type=script&lang=js"
import style0 from "./CreateTaxRate.vue?vue&type=style&index=0&id=0b6b4064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b4064",
  null
  
)

export default component.exports